function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M8.01013 10.8043C6.659 10.8043 5.56604 9.75165 5.56604 8.42954C5.56604 7.10744 6.659 6.04639 8.01013 6.04639C9.36127 6.04639 10.4284 7.10744 10.4284 8.42954C10.4284 9.75165 9.36127 10.8043 8.01013 10.8043Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M15.7727 10.4168C15.6092 10.1642 15.3769 9.91158 15.0757 9.75158C14.8347 9.63368 14.6798 9.44 14.5421 9.21263C14.1032 8.48842 14.3614 7.53684 15.0929 7.10737C15.9535 6.62737 16.2289 5.55789 15.7297 4.72421L15.1531 3.73053C14.6626 2.89684 13.5868 2.60211 12.7348 3.09053C11.9775 3.49474 11.005 3.22526 10.5661 2.50947C10.4284 2.27368 10.351 2.02105 10.3682 1.76842C10.394 1.44 10.2907 1.12842 10.1358 0.875789C9.81742 0.353684 9.24082 0 8.60398 0H7.39054C6.76231 0.0168421 6.18571 0.353684 5.86729 0.875789C5.70377 1.12842 5.60911 1.44 5.62632 1.76842C5.64353 2.02105 5.56608 2.27368 5.42838 2.50947C4.98948 3.22526 4.017 3.49474 3.26829 3.09053C2.40769 2.60211 1.34055 2.89684 0.841407 3.73053L0.264808 4.72421C-0.225732 5.55789 0.0496586 6.62737 0.901648 7.10737C1.63315 7.53684 1.89133 8.48842 1.46104 9.21263C1.31473 9.44 1.15983 9.63368 0.91886 9.75158C0.626258 9.91158 0.368079 10.1642 0.230384 10.4168C-0.0880367 10.9389 -0.0708248 11.5958 0.247596 12.1432L0.841407 13.1537C1.15983 13.6926 1.75364 14.0295 2.37327 14.0295C2.66587 14.0295 3.01011 13.9453 3.2855 13.7768C3.50065 13.6337 3.75883 13.5832 4.04282 13.5832C4.89481 13.5832 5.60911 14.2821 5.62632 15.1158C5.62632 16.0842 6.41807 16.8421 7.41636 16.8421H8.58677C9.57645 16.8421 10.3682 16.0842 10.3682 15.1158C10.394 14.2821 11.1083 13.5832 11.9603 13.5832C12.2357 13.5832 12.4939 13.6337 12.7176 13.7768C12.993 13.9453 13.3287 14.0295 13.6299 14.0295C14.2409 14.0295 14.8347 13.6926 15.1531 13.1537L15.7555 12.1432C16.0653 11.5789 16.0912 10.9389 15.7727 10.4168Z",
  fill: "#C4C4C4"
});

function SvgSettingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.f47512fb.svg";
export { ForwardRef as ReactComponent };